export { BioEntitiesSubmapItem } from './BioEntitiesSubmapItem.component';
